export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11137.b8bbca83.jpg";